
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocation1 as ObiLocation1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-1.js';
 
 
 

 
 export const ObiLocation1 = createComponent({
   react: React,
   tagName: 'obi-location-1',
   elementClass: ObiLocation1Element,
   events: {
     
   }
  });
 
 